import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Typography, Box, Chip, CircularProgress
} from '@material-ui/core';
import {  makeStyles , useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '520px',
    
    color: '#f8fafc'
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-root': { color: '#f8fafc' },
    '& .MuiInputLabel-root': { color: theme.palette.text.secondary },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#334155' },
  },
  label: { color: theme.palette.text.secondary, fontSize: '0.8rem', marginBottom: 4 },
  value: { color: theme.palette.text.primary, marginBottom: 12 },
  replyBox: {
    background: 'rgba(16,185,129,0.08)',
    border: '1px solid rgba(16,185,129,0.2)',
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
  },
}));

const categoryColors = {
  suggestion: '#10b981',
  bug_report: '#ef4444',
  usability_issue: '#f59e0b',
};

export default function FeedbackDetailDialog({ open, feedback, onClose, onSave }) {
  const classes = useStyles();
  
  const theme = useTheme();
const [reply, setReply] = useState(feedback?.adminReply || '');
  const [saving, setSaving] = useState(false);

  if (!feedback) return null;

  const handleSave = async () => {
    setSaving(true);
    await onSave(feedback.id, { adminReply: reply }, feedback);
    setSaving(false);
  };


  const formatDate = (ts) => {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString();
  };

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }} maxWidth="sm" fullWidth>
      <DialogTitle>Feedback Details</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <Typography className={classes.label}>User</Typography>
          <Typography className={classes.value}>{feedback.userName} ({feedback.userEmail})</Typography>
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Category</Typography>
          <Chip
            label={feedback.category}
            size="small"
            style={{
              backgroundColor: `${categoryColors[feedback.category] || '#64748b'}20`,
              color: categoryColors[feedback.category] || '#94a3b8',
              fontWeight: 600,
            }}
          />
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Submitted</Typography>
          <Typography className={classes.value}>{formatDate(feedback.createdAt)}</Typography>
        </Box>
        <Box mb={2}>
          <Typography className={classes.label}>Feedback</Typography>
          <Typography className={classes.value} style={{ whiteSpace: 'pre-wrap' }}>{feedback.feedback}</Typography>
        </Box>

        {feedback.adminReply && (
          <Box className={classes.replyBox} mb={2}>
            <Typography className={classes.label} style={{ color: '#10b981' }}>Your Reply</Typography>
            <Typography className={classes.value} style={{ whiteSpace: 'pre-wrap' }}>{feedback.adminReply}</Typography>
            {feedback.repliedAt && (
              <Typography style={{ color: theme.palette.text.secondary, fontSize: '0.75rem' }}>
                {formatDate(feedback.repliedAt)}
              </Typography>
            )}
          </Box>
        )}

        <TextField
          label="Admin Reply"
          fullWidth
          multiline
          minRows={3}
          variant="outlined"
          className={classes.textField}
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          placeholder="Write your reply to the user..."
        />
      </DialogContent>
      <DialogActions >
        <Button onClick={onClose} color="textSecondary">Close</Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disableElevation
          disabled={saving || !reply.trim()}
        >
          {saving ? <CircularProgress size={20} /> : 'Save Reply'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
